import {
  GET_PROCESS,
  GET_PROCESS_SUCCESS,
  GET_PROCESS_ERROR,
  EXECUTE_PROCESS,
  EXECUTE_PROCESS_SUCCESS,
  EXECUTE_PROCESS_ERROR,
  UPDATE_PROCESS_DETAILS_STATE,
} from "../actions";

const INIT_STATE = {
  processId: null,
  process: null,
  processDetailsError: "",
  executeProcessSuccess: "",
  executeProcessError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROCESS:
      return {
        ...state,
        loading: true,
        processDetailsError: "",
        processId: action.payload.processId,
      };
    case GET_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        processDetailsError: "",
        process: action.payload.process,
      };
    case GET_PROCESS_ERROR:
      return {
        ...state,
        loading: false,
        processDetailsError: action.payload ? action.payload.message : "",
      };
    case EXECUTE_PROCESS:
      return {
        ...state,
        loading: true,
        executeProcessSuccess: "",
        executeProcessError: "",
        processId: state.processId,
      };
    case EXECUTE_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        executeProcessError: "",
        executeProcessSuccess: action.payload
          ? action.payload.successMessage
          : "",
      };
    case EXECUTE_PROCESS_ERROR:
      return {
        ...state,
        loading: false,
        executeProcessSuccess: "",
        executeProcessError: action.payload ? action.payload.message : "",
      };
    case UPDATE_PROCESS_DETAILS_STATE:
      return { ...state, ...action.payload.updatedValues };
    default:
      return { ...state };
  }
};
